import { render } from "./changeTransporter.vue?vue&type=template&id=bb9152cc&scoped=true"
import script from "./changeTransporter.vue?vue&type=script&lang=js"
export * from "./changeTransporter.vue?vue&type=script&lang=js"

import "./changeTransporter.vue?vue&type=style&index=0&id=bb9152cc&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb9152cc"]])

export default __exports__